export default __webpack_public_path__ + "static/media/13-herbstlaub.4c43b7f3.svg";